/**
 * Phonics Letter Dd — 课程数据配置
 *
 * 媒体资源基础路径（对应服务器 /media/phonics/dd/）
 *
 * 统一数据结构：
 * {
 *   layout: '...',
 *   // vocab 布局：videos[] 各带 video.lines（vocab words），storyLines 单独放
 *   videos: [{ src, poster?, startTime?, endTime?, role?, lines? }],
 *   storyLines?: [{ en, cn?, audioEn, audioCn? }],
 *   // 简单布局：统一 videos[] + splitAt + lines[]
 *   lines?: [{ en, cn?, audioEn, audioCn? }],
 *   splitAt?: number,
 * }
 */

const MEDIA_BASE = '/media/phonics/dd';
const V = 'v1';

export const letterData = {
  letter: 'D',
  title: 'Phonics',
  subtitle: 'Letter D',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段
  songVideo: {
    src: `${MEDIA_BASE}/Dd.mp4?${V}`,
    startTime: 9,
    endTime: 83,
  },

  // Step 2: 4 格单词视频
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image12.png?${V}` },
  ],

  storySections: [
    // Step 3: Learn the Story (1) — vocab-stack-story-right（左2词汇上下叠，右故事视频放大）
    // splitAt=2: 前2个视频 = vocab，各带 video.lines（单词）
    {
      label: 'Learn the Story (1)',
      layout: 'vocab-stack-story-right',
      videos: [
        {
          src: `${MEDIA_BASE}/video_story1_run.mp4?${V}`,
          poster: `${MEDIA_BASE}/image14.png?${V}`,
          role: 'vocab',
          lines: [
            { en: 'run', cn: '跑', audioEn: `${MEDIA_BASE}/w_en_run.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_run.mp3?${V}` },
          ],
        },
        {
          src: `${MEDIA_BASE}/video_story1_are_running.mp4?${V}`,
          poster: `${MEDIA_BASE}/image15.png?${V}`,
          role: 'vocab',
          lines: [
            { en: 'are running', cn: '正在跑', audioEn: `${MEDIA_BASE}/w_en_are_running.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_are_running.mp3?${V}` },
          ],
        },
        {
          src: `${MEDIA_BASE}/Dd.mp4?${V}`,
          poster: `${MEDIA_BASE}/image13.png?${V}`,
          startTime: 27,
          endTime: 41,
          role: 'story',
        },
      ],
      splitAt: 2,
      storyLines: [
        { en: 'Ducks are running.', audioEn: `${MEDIA_BASE}/s_en_ducks_are_running.mp3?${V}` },
        { en: 'Dogs are running.', audioEn: `${MEDIA_BASE}/s_en_dogs_are_running.mp3?${V}` },
      ],
    },

    // Step 4: Learn the Story (2) — vocab-story-swap（等宽互换：dance视频左，故事视频右）
    {
      label: 'Learn the Story (2)',
      layout: 'vocab-story-swap',
      videos: [
        {
          src: `${MEDIA_BASE}/video_story2_dancing.mp4?${V}`,
          poster: `${MEDIA_BASE}/image17.png?${V}`,
          role: 'vocab',
          lines: [
            { en: 'dance', cn: '跳舞', audioEn: `${MEDIA_BASE}/w_en_dance.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_dance.mp3?${V}` },
            { en: 'are dancing', cn: '正在跳舞', audioEn: `${MEDIA_BASE}/w_en_are_dancing.mp3?${V}`, audioCn: `${MEDIA_BASE}/w_cn_are_dancing.mp3?${V}` },
          ],
        },
        {
          src: `${MEDIA_BASE}/Dd.mp4?${V}`,
          poster: `${MEDIA_BASE}/image16.png?${V}`,
          startTime: 45,
          endTime: 58,
          role: 'story',
        },
      ],
      splitAt: 1,
      storyLines: [
        { en: 'Donkeys are dancing.', audioEn: `${MEDIA_BASE}/s_en_donkeys_are_dancing.mp3?${V}` },
        { en: 'Dinosaurs are dancing.', audioEn: `${MEDIA_BASE}/s_en_dinosaurs_are_dancing.mp3?${V}` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
